/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { FormCheck, FormControl } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { ImportUserFormModel } from '../../../modules/admin/models';
import { FormErrors, SelectField, SelectItem } from '../form';
import { TableColumn, TableItemAction } from './models';

import CommentIcon from '../../../assets/images/comment-icon.svg';
import { SmallSecondaryButton } from '../button';

export interface TableBodyProps<T> {
  data: Array<T>;
  columns: Array<TableColumn<T>>;
  itemActions?: Array<TableItemAction<T>>;
  selectable?: boolean;
  selectedRows?: Array<number>;
  onSelectRow?: (val: any) => void;
}

export interface EditCellProps {
  toggleEdit: boolean;
  key: string;
  index: number;
}

export interface ColOptions {
  inputType?: string;
  defaultValue?: string;
  possibleValues?: Array<SelectItem>;
  validationFunction?: (val: any) => FormErrors<ImportUserFormModel>;
  onChange?: (e: React.SyntheticEvent<any>, record: Record<any, any>, index: any) => void;
  onToggleEdit?: (key: string, index: number) => void;
  onSubmitCell?: () => void;
  getSelected?: (item?: any, options?: Array<any>) => Array<SelectItem> | undefined;
  hidden?: boolean;
  customContent?: boolean;
  toggleEditCell?: EditCellProps;
}

export const TableBody = <T,>({
  data,
  columns,
  itemActions,
  selectable,
  onSelectRow,
  selectedRows,
}: TableBodyProps<T>): React.ReactElement => {
  const selectRow = (val: any) => {
    if (onSelectRow) {
      onSelectRow(val);
    }
  };

  const renderCells = (record: Record<string, unknown>, index: number, options: Record<string, ColOptions>) => {
    return Object.keys(record).map((key) => {
      let value = record[key] ? record[key] : options[key].defaultValue;
      const { inputType, hidden, possibleValues, customContent, toggleEditCell } = options[key];
      const callback = options[key]?.onChange;
      const callbackEditCell = options[key]?.onToggleEdit;
      const callbackSubmitCell = options[key]?.onSubmitCell;
      const comparator = options[key]?.getSelected;
      if (comparator) value = comparator ? comparator(record, possibleValues) : value;
      const changeHandler = (e: any) => {
        if (callback) {
          callback(e, record, key);
        }
      };
      const editCellHandler = () => {
        if (callbackEditCell) {
          callbackEditCell(key, index);
        }
      };
      const submitCellHandler = () => {
        if (callbackSubmitCell) {
          callbackSubmitCell();
        }
      };

      if (hidden) {
        return undefined;
      }
      if (inputType === 'text' || inputType === 'date') {
        return (
          <td key={`${key}-${index}`} className="px-1">
            <FormControl onChange={changeHandler} type={inputType} value={value as string} />
          </td>
        );
      }
      if (inputType === 'select') {
        return (
          <td key={`${key}-${index}`} className="px-1">
            <FormControl onChange={changeHandler} as="select" className="w-100" value={value as string}>
              {possibleValues?.map((o) => (
                <option key={`${key}-${index}-${o.value}`} value={o.value}>
                  {o.label}
                </option>
              ))}
            </FormControl>
          </td>
        );
      }
      if (inputType === 'multiselect') {
        return (
          <td key={`${key}-${index}`} className="px-1">
            <Form
              initialValues={{ groups: value }}
              onSubmit={() => {}}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="d-flex justify-content-end">
                  <SelectField
                    className="mb-0 core-table__table-body-multiselect"
                    name="groups"
                    isMulti
                    multiValueCompact
                    options={possibleValues}
                    onChange={changeHandler}
                  />
                </form>
              )}
            />
          </td>
        );
      }
      // if cell needs to be customized
      if (customContent) {
        switch (key) {
          case 'commentsCount':
            return (
              <td key={`${key}-${index}`} className="ps-0 table-body-value pe-4">
                {value && value !== 'N/A' && value !== undefined && (value as number) > 0 ? (
                  <div className="black-marked-cell comments">
                    <img src={CommentIcon} className="me-1" alt="comment icon" />
                    <span>{value as React.ReactElement}</span>
                  </div>
                ) : (
                  <div className="gray-placeholder-cell studentTags" />
                )}
              </td>
            );
          case 'sequenceGood':
            return (
              <td key={`${key}-${index}`} className="ps-0 table-body-value pe-4">
                {value !== 'N/A' ? (
                  <div className="black-marked-cell studentTags">
                    <i className={`fa ${value === 1 ? 'fa-thumbs-up' : 'fa-thumbs-down'} me-1`} aria-hidden="true" />
                    <span>{value === 1 ? 'Good' : 'Bad'}</span>
                  </div>
                ) : (
                  <div className="gray-placeholder-cell studentTags" />
                )}
              </td>
            );
          case 'gradePulseSequence':
            return (
              <td key={`${key}-${index}`} className="table-body-value ">
                <span className="d-flex align-items-center">
                  {value !== 'N/A' && (value as React.ReactElement).props.children ? (
                    <>
                      <span className="fw-bold">{value as string}</span>
                      <i className="fa fa-star grade ps-1" />
                    </>
                  ) : (
                    'N/A'
                  )}
                </span>
              </td>
            );
          case 'type':
            return (
              <td key={`${key}-${index}`} className="table-body-value ">
                {value !== 'N/A' ? (
                  <div
                    className={` ${
                      // eslint-disable-next-line no-nested-ternary
                      value === 'error'
                        ? 'table-error-cell'
                        : value === 'warning' || value === 'information'
                        ? 'table-warning-cell'
                        : ''
                    }`}
                  >
                    <span className="text-capitalize">{value as string}</span>
                  </div>
                ) : (
                  <div className="gray-placeholder-cell studentTags" />
                )}
              </td>
            );
          case 'license':
            return (
              <td key={`${key}-${index}`} className="px-1 table-body-value text-capitalize">
                {value as React.ReactElement}
              </td>
            );
          case 't1':
          case 't2':
            return (
              <td key={`${key}-${index}`} className="px-1 table-body-value cell-edit-style">
                {toggleEditCell &&
                !toggleEditCell?.toggleEdit &&
                key !== toggleEditCell.key &&
                index !== toggleEditCell.index ? (
                  <>
                    <span>{value as React.ReactElement}</span>
                    <i
                      className="fa fa-pencil-square-o ps-1"
                      role="presentation"
                      style={{ color: '#0079B9' }}
                      onClick={editCellHandler}
                      onKeyDown={editCellHandler}
                    />
                  </>
                ) : toggleEditCell &&
                  !toggleEditCell?.toggleEdit &&
                  key === toggleEditCell.key &&
                  index === toggleEditCell.index ? (
                  <div className="d-flex align-items-center">
                    <Form
                      onSubmit={submitCellHandler}
                      render={({ handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                          <FormControl onChange={changeHandler} type="number" defaultValue={value as number} />
                        </form>
                      )}
                    />
                    <i
                      className="fa fa-floppy-o ms-3"
                      role="presentation"
                      style={{ color: '#0079B9' }}
                      onClick={submitCellHandler}
                      onKeyDown={submitCellHandler}
                    />
                  </div>
                ) : (
                  <>
                    <span>{value as React.ReactElement}</span>
                    <i
                      className="fa fa-pencil-square-o ps-1"
                      role="presentation"
                      style={{ color: '#0079B9' }}
                      onClick={editCellHandler}
                      onKeyDown={editCellHandler}
                    />
                  </>
                )}
              </td>
            );
          default:
            break;
        }
      }
      return (
        <td key={`${key}-${index}`} className="px-1 table-body-value">
          {value as React.ReactElement}
        </td>
      );
    });
  };

  const isDisabled = (action: any, item: any): boolean => {
    if (action.disabled !== undefined) {
      return action.disabled;
    }
    if (action.isDisabled) {
      return action.isDisabled(item);
    }
    return false;
  };

  const actionHandler = (action: any, item: any) => {
    action.clickHandler(item);
  };

  const renderActions = (item: T | any, actions: Array<TableItemAction<T>>) => {
    let isItemSelected: any;
    if (selectedRows && selectedRows.length > 0 && item?.id) {
      isItemSelected = selectedRows?.findIndex((row) => row === item.id);
    }

    return (
      <td className="text-end px-1 text-nowrap">
        {actions.map((action, idx) => {
          const customClass = action.customClass || '';

          return (
            <SmallSecondaryButton
              className={customClass}
              key={idx}
              isDisabled={isDisabled(action, item)}
              onClick={() => actionHandler(action, item)}
            >
              {action.labelLeft &&
                (isItemSelected !== undefined && isItemSelected > -1 ? action.checkedTitle : action.title)}
              {action.showCheckbox && (
                <input
                  disabled={action.disabled}
                  type="checkbox"
                  className="me-2"
                  checked={isItemSelected !== undefined && isItemSelected > -1}
                  onChange={() => {}}
                />
              )}

              {!action.labelLeft &&
                (isItemSelected !== undefined && isItemSelected > -1 ? action.checkedTitle : action.title)}
            </SmallSecondaryButton>
          );
        })}
      </td>
    );
  };

  return (
    <tbody>
      {data &&
        data?.map((item, idx) => {
          const record = item as Record<string, unknown>;
          const dataObj: Record<string, unknown> = {};
          const options: Record<string, ColOptions> = {};

          columns
            .filter((c) => c.key !== 'itemActions')
            .forEach((k) => {
              const val = record[k.key];
              options[k.key] = {
                inputType: undefined,
                possibleValues: undefined,
                validationFunction: undefined,
                defaultValue: undefined,
                onChange: undefined,
                onToggleEdit: undefined,
                onSubmitCell: undefined,
                hidden: undefined,
                customContent: undefined,
                toggleEditCell: undefined,
              };
              options[k.key].inputType = k.inputType;
              options[k.key].possibleValues = k.possibleValues;
              options[k.key].validationFunction = k.validation;
              options[k.key].getSelected = k.getSelected;
              options[k.key].defaultValue = k.defaultValue;
              options[k.key].onChange = k.onChange;
              options[k.key].onToggleEdit = k.onToggleEdit;
              options[k.key].onSubmitCell = k.onSubmitCell;
              options[k.key].hidden = k.hidden;
              options[k.key].customContent = k.customContent;
              options[k.key].toggleEditCell = k.toggleEditCell;
              if (k.rowParser) {
                dataObj[k.key] = k.rowParser(item);
              } else if (val !== undefined) {
                dataObj[k.key] = val;
              } else {
                dataObj[k.key] = 'N/A';
              }
            });

          return (
            <tr key={`row-${idx}`}>
              {selectable && (
                <td>
                  <FormCheck
                    checked={selectedRows?.includes(idx)}
                    type="checkbox"
                    id={`row-select-${idx}`}
                    onChange={() => selectRow(idx)}
                  />
                </td>
              )}
              {renderCells(dataObj, idx, options)}
              {itemActions && renderActions(item, itemActions)}
            </tr>
          );
        })}
    </tbody>
  );
};
